import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Custom smooth scroll for anchor links (slower than default)
document.addEventListener('click', function (e) {
  // Only handle anchor tags with href starting with '#'
  const anchor = e.target.closest('a[href^="#"]');
  if (!anchor) return;
  const hash = anchor.getAttribute('href');
  if (!hash || hash.length < 2) return;
  const target = document.getElementById(hash.slice(1));
  if (!target) return;
  // Prevent default jump
  e.preventDefault();
  // Calculate scroll position
  const startY = window.scrollY;
  const endY = target.getBoundingClientRect().top + window.scrollY;
  const duration = 1200; // ms
  const startTime = performance.now();
  function scrollStep(now) {
    const elapsed = now - startTime;
    const progress = Math.min(elapsed / duration, 1);
    // easeOutCubic: fast start, slow finish
    const ease = 1 - Math.pow(1 - progress, 3);
    window.scrollTo(0, startY + (endY - startY) * ease);
    if (progress < 1) {
      requestAnimationFrame(scrollStep);
    } else {
      // Optionally update the hash in the URL
      window.history.replaceState(null, '', hash);
    }
  }
  // Start the animation immediately
  scrollStep(performance.now());
});
